export enum Sounds {
  Scratch,
  MouseClick,
  PopupDrop,
  CardDrop,
  Countdown,
  MoveUp,
  MoveDown,
  DigitalTyping,
  Spin,
  CardReveal,
  SpinStop,
  Result,
  Lose,
  Win,
  Explode,
  Flush,
  BigWin,
  Dispense,
  Fireworks,
  BountyWin,
  CoinDrop,
  BigLoss,
  JackpotWin,
  Woosh,
  Fold,
  Eliminated,
  TicketClick,
  ChipUp,
  ChipDown,
}

export type SoundState = {
  volume: number;
  sounds: Record<Sounds, Howl>;
}

export type SoundActions = {
  initialize: () => void;
  play: (sound: Sounds, rate?: number, loop?: boolean) => void;
  stop: (sound: Sounds) => void;
  stopAll: () => void;
  fadeOut: (sound: Sounds, duration?: number) => void;
  toggleVolume: () => void;
  setVolume: (volume: number) => void;
  getHowl: (sound: Sounds) => Howl;
}

